/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useMemo, useState } from "react";
import { Container } from "@material-ui/core";
import PageTitle from "../../../../components/pageTitle/PageTitle";
import moment from "moment-timezone";
import * as Excel from 'exceljs';
import { downloadPDF, downloadExcel } from "../../DownloadReportUtils";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import dayjs from "dayjs";
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import CircularProgress from "@mui/material/CircularProgress";
import ActionRender from "../../ActionRender";
import AuthContext from "../../../../hooks/authContext";
import SingleSelectNew from "../../../../components/SelectField/SingleSelectNew";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../../../components/ui/card";
import { Button } from "../../../../components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "../../../../components/ui/popover";
import { Label } from "../../../../components/ui/label";
import { Download, Eye, FileSpreadsheet, FileText, Filter, Info, Mail } from "lucide-react";
import { getCompanyEmployees } from "../../../../services/apiservices/employee";
import ThemeTable from "../../../../components/Table/ThemeTable";
import EmailReports from "../../EmailReports";
import { CSVLink } from "react-csv";
import { getCompanyClients } from "../../../../services/apiservices/client";
import { getSuppliesNotesReports, getSuppliesReports } from "../../../../services/apiservices/supplies";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../../../../components/ui/tooltip";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "../../../../components/ui/hover";
import { Badge } from "../../../../components/ui/badge";
import { MobileUrgentSupplyReport } from "../MobileViewReports";
import { WarningAmber } from "@mui/icons-material";
import { getSettings } from "../../../../services/apiservices/settings";
import { trackEvent, CMS_EVENTS } from "../../../../services/apiservices/analytics";

function UrgentSupplyPatterns(props) {

  const csvHeaders = [
    "Employee",
    "Date",
    "Items",
    "QTY",
    "Client",
    "Urgent Request Flag",
    "Approved (hrs)",
    "Time"
  ];

  const [employeeList, setEmployeeList] = useState([]);
  const [employeeListMaster, setEmployeeListMaster] = useState([]);
  const [clientsListCSV, setClientListCSV] = useState([csvHeaders]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [empName, setEmpName] = useState("All");
  const [employee, setEmployee] = useState();
  const [clients, setClients] = useState();
  const [settingsData, setSettingsData] = useState();
  const [openEmailDialog, setOpenEmailDialog] = useState(false);
  const [loader, setLoader] = useState(false);
  const [empNameList, setEmpNameList] = useState([
    { label: "All", value: "All" },
  ]);
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width:767px)');
  const isLandscape = useMediaQuery('(min-width: 771px) and (max-width: 940px)');
  const auth = useContext(AuthContext);
  const { setReportData } = auth || {};
  const companyId = auth?.userProfile?.role === "companyUser" ? auth?.userProfile?.id : auth?.userProfile?.companyId;

  const getColumns = () => {
    const columns = [
      {
        id: "employeeName",
        numeric: false,
        disablePadding: false,
        label: "Employee",
        isSortable: false,
        gray: true,
      },
      {
        id: "date",
        numeric: false,
        disablePadding: false,
        label: "Date",
        isSortable: false,
        gray: true,
      },
      {
        id: "items",
        numeric: false,
        disablePadding: false,
        label: "Items",
        isSortable: false,
        gray: true,
      },
      {
        id: "qty",
        numeric: false,
        disablePadding: false,
        label: "QTY",
        isSortable: false,
        gray: true,
      },
      {
        id: "client",
        numeric: false,
        disablePadding: false,
        label: "Client",
        isSortable: false,
        gray: true,
      },
      {
        id: "urgent",
        numeric: false,
        disablePadding: false,
        label: "Urgent Request Flag",
        isSortable: false,
        gray: true,
      },
      {
        id: "approved",
        numeric: false,
        disablePadding: false,
        label: "Approved (hrs)",
        isSortable: false,
        gray: true,
      },
      {
        id: "time",
        numeric: false,
        disablePadding: false,
        label: "Fulfilled Time (hrs)",
        isSortable: false,
        gray: true,
      },
      {
        id: "Action",
        numeric: false,
        disablePadding: false,
        label: "Action",
        isSortable: false,
        gray: true,
      },
    ];

    if (isMobile || isLandscape) {
      return columns.filter(col => col.id !== "employeeName" && col.id !== "appointmentDate" && col.id !== "Action");
    }

    return columns;
  };

  const getDatatoDownload = (rcellItem) => {
    let clientCSV = [];
    if (!Array.isArray(rcellItem)) {
      clientCSV = employeeList?.filter(
        (item) => item.employeNameId === rcellItem.employeNameId
      );
      clientCSV = clientCSV?.map((item) => {
        return [
          item?.employeeName,
          item?.date || item?.date,
          item?.items,
          item?.qty,
          item?.client,
          item?.urgent,
          item?.approved,
          item?.time,
        ];
      });
    } else {
      clientCSV = rcellItem?.map((item) => {
        return [
          item?.employeeName,
          item?.date || item?.date,
          item?.items,
          item?.qty,
          item?.client,
          item?.urgent,
          item?.approved,
          item?.time,
        ];
      });
    }
    return clientCSV;
  }

  const getDatatoFullDownload = (rcellItem) => {
    if (rcellItem) {
      employeeList?.filter(
        (item) => item.employeNameId === rcellItem.employeNameId
      );
      return [
        rcellItem?.employeeName,
        rcellItem?.date,
        rcellItem?.items,
        rcellItem?.qty,
        rcellItem?.client,
        rcellItem?.urgent,
        rcellItem?.approved,
        rcellItem?.time,
      ];
    } else {
      return [
        rcellItem?.employeeName,
        rcellItem?.date,
        rcellItem?.items,
        rcellItem?.qty,
        rcellItem?.client,
        rcellItem?.urgent,
        rcellItem?.approved,
        rcellItem?.time,
      ];
    }
  }

  useEffect(() => {
    trackEvent(CMS_EVENTS.REPORT_VIEWED, {
      user_id: auth?.userProfile?.id,
      report_name: "Urgent Supply Patterns Reports",
    });
    const getEmployeesData = async () => {
      const [employeeRes, clientRes, settingsRes] = await Promise.all([
        new Promise((resolve, reject) => {
          getCompanyEmployees(
            companyId,
            (res) => resolve(res),
            (err) => resolve({ status: false, data: [] })
          );
        }),
        new Promise((resolve) => getCompanyClients(companyId, resolve)),
        new Promise((resolve) =>
          getSettings("client_settings", companyId, (res) => resolve(res?.data))
        ),
      ]);
      const details = employeeRes?.data;
      const employee = details?.map((item) => {
        return {
          value: item?.id,
          label: `${item?.firstName} ${item?.lastName}`,
        };
      })?.sort((a, b) => a?.label?.localeCompare(b?.label));
      const Clientdetails = clientRes?.data;
      const filteredData = settingsRes?.filter(
        (item) => !item.deleted
      );
      setSettingsData(filteredData?.length ? filteredData : []);
      setClients(Clientdetails);
      setEmployee(details);
      setEmpNameList([{ label: "All", value: "All" }, ...employee]);
    };
    getEmployeesData();
  }, []);

  const downloadForExcel = async (rcellItem, emailSend) => {
    let wb = new Excel.Workbook();
    let ws = wb.addWorksheet('Urgent Supply Patterns Report');
    const clientCSV = getDatatoDownload(rcellItem?.records ? rcellItem?.records : rcellItem);
    let fileName;
    if (rcellItem?.records) {
      fileName = `UrgentSupplyPatternsReport_${rcellItem?.records?.[0]?.employeeName}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`;
    } else {
      fileName = `UrgentSupplyPatternsReport_${rcellItem?.employeeName}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`;
    }
    let name = true;
    return await downloadExcel(clientCSV, csvHeaders, wb, ws, fileName, emailSend, name)
  }

  const downloadForPDF = async (rcellItem, emailSend) => {
    const clientCSV = getDatatoDownload(rcellItem?.records ? rcellItem?.records : rcellItem);
    let fileName;
    if (Array.isArray(rcellItem?.records)) {
      fileName = `UrgentSupplyPatternsReport_${rcellItem?.records?.[0]?.employeeName}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`;
    } else {
      fileName = `UrgentSupplyPatternsReport_${rcellItem?.employeeName}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`;
    }
    let name = true;
    const logo = settingsData?.[0]?.companyLogo;
    return await downloadPDF(logo, clientCSV, csvHeaders, fileName, emailSend, name);
  }

  const setDownloadCSVData = (event, done, rcellItem) => {
    const clientCSV = getDatatoDownload(rcellItem?.records ? rcellItem?.records : rcellItem);

    const reportName = "Urgent Supply Patterns Report";
    const employeName = Array.isArray(rcellItem) ? `${rcellItem?.records?.[0]?.employeeName}` : `${rcellItem?.employeeName}`;
    const reportPeriod = `${moment(startDate).format("YYYY-MM-DD")} to ${moment(endDate).format("YYYY-MM-DD")}`;

    // Create the report details rows
    const reportDetails = [
      [`Employee Name: ${employeName}`],
      [`Report Name: ${reportName}`],
      [`Report Period: ${reportPeriod}`],
      [],
      [...csvHeaders],
      ...clientCSV
    ];

    // Set the CSV data
    setClientListCSV(reportDetails);
    done();
  };

  const setDownloadFullCSVData = (event, done) => {
    const clientCSV = employeeList.map((item) => getDatatoFullDownload(item));
    let empNamefordwonLoad = 'All'

    if (empName !== 'All') {
      empNamefordwonLoad = empNameList?.filter((item) => item.value === empName)[0].label
    }

    const reportName = "Urgent Supply Patterns Report";
    const reportPeriod = `${moment(startDate).format("YYYY-MM-DD")} to ${moment(endDate).format("YYYY-MM-DD")}`;

    const reportDetails = [
      [`Employee Name: ${empNamefordwonLoad}`],
      [`Report Name: ${reportName}`],
      [`Report Period: ${reportPeriod}`],
      [],
      [...csvHeaders],
      ...clientCSV
    ];

    setClientListCSV(reportDetails);
    done();
  };

  const downloadForFullPDF = async (emailSend) => {
    const clientCSV = employeeList.map((item) => getDatatoFullDownload(item));
    let empNamefordwonLoad = 'All'

    if (empName !== 'All') {
      empNamefordwonLoad = empNameList?.filter((item) => item.value === empName)[0].label
    }
    let fileName = `UrgentSupplyPatternsReport_${empNamefordwonLoad}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`
    let name = true;
    const logo = settingsData?.[0]?.companyLogo;
    return await downloadPDF(logo, clientCSV, csvHeaders, fileName, emailSend, name);
  }

  const downloadForFullExcel = async (emailSend) => {
    let wb = new Excel.Workbook();
    let ws = wb.addWorksheet('Urgent Supply Patterns Report');
    let empNamefordwonLoad = 'All'

    const clientCSV = employeeList.map((item) => getDatatoFullDownload(item));

    if (empName !== 'All') {
      empNamefordwonLoad = empNameList?.filter((item) => item.value === empName)[0].label
    }
    let fileName = `UrgentSupplyPatternsReport_${empNamefordwonLoad}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`
    let name = true;
    return await downloadExcel(clientCSV, csvHeaders, wb, ws, fileName, emailSend, name)
  }


  const handleEmailIconClick = async (rcellItem) => {
    const emailSend = true;
    let name;
    if (Array.isArray(rcellItem?.records)) {
      name = rcellItem?.records?.[0]?.employeeName;
    } else {
      name = rcellItem?.employeeName;
    }

    const [excelBlob, pdfBlob] = await Promise.all([
      downloadForExcel(rcellItem, emailSend),
      downloadForPDF(rcellItem, emailSend),
    ]);
    // Convert the Excel blob to a base64-encoded string
    const reader = new FileReader();
    reader.readAsDataURL(excelBlob);
    reader.onloadend = function () {
      const base64Data = reader.result;
      setReportData((prev) => ({
        ...prev,
        FileName: "Urgent Supply Patterns Report",
        ReportsName: "Employee Report",
        Name: name,
        Date: startDate,
        EndDate: endDate,
        pdf: pdfBlob,
        storedData: base64Data,
        fullData: "",
        fullExcelData: "",
      }));
      setOpenEmailDialog(true);
    };
  };

  const handelEmailFullReport = async () => {
    const emailSend = true;

    let empNamefordwonLoad = "All";

    if (empName !== "All") {
      empNamefordwonLoad = empNameList.filter(
        (item) => item.value === empName
      )[0].label;
    }

    const [fullReport, fullExcelReport] = await Promise.all([
      downloadForFullPDF(emailSend),
      downloadForFullExcel(emailSend),
    ]);
    const reader = new FileReader();
    reader.readAsDataURL(fullExcelReport);
    reader.onloadend = function () {
      const base64Data = reader.result;
      setReportData((prev) => ({
        ...prev,
        FileName: "Urgent Supply Patterns Report",
        ReportsName: "Employee Report",
        Name: empNamefordwonLoad,
        Date: startDate,
        EndDate: endDate,
        fullData: fullReport,
        fullExcelData: base64Data,
        pdf: "",
        storedData: "",
      }));
      setOpenEmailDialog(true);
    };
  };

  const handleEmpNameChange = (e) => {

    const str = e;

    setEmpName(str);
    if (str === "All") {
      setEmployeeList(employeeListMaster);
    } else {
      setEmployeeList(() =>
        employeeListMaster.filter((itme) => {
          let returnFlg = true;
          if (returnFlg) {
            returnFlg = str.includes(itme?.employeNameId);
          }
          return returnFlg;
        })
      );
    }
  };

  const handleGenerateReport = async () => {
    setLoader(true);
    let paramStartDate = "";
    let paramEndDate = "";

    paramStartDate = startDate;
    paramEndDate = endDate;
    getReportListData(paramStartDate, paramEndDate);
  }

  const hoursDiff = (start, end) => {
    const fmt = "MMMM D, YYYY [at] h:mm:ss A [UTC]Z";
    const diffMs = moment.parseZone(end, fmt).diff(moment.parseZone(start, fmt));
    const hrs = Math.floor(moment.duration(diffMs).asHours());
    return hrs >= 1 ? `${hrs}h` : "1h";
  };

  const mapWidhtEmpList = async ({ notes, supplies }) => {
    const finaleData = supplies?.map((resItem) => {
      const userTimeSheet = employee?.filter(
        (itm) => itm.id === resItem?.createdBy
      );

      const clientDetails = clients?.find((item) => item?.id === resItem?.clientId);
      const note = notes?.filter((item) => item?.orderId === resItem?.id);
      if (note?.length) {
        const latestNote = note?.reduce((best, curr) => curr?.createdAt.seconds > best?.createdAt.seconds ? curr : best, note[0]);
        resItem["comments"] = latestNote?.note || "";
      } else {
        resItem["comments"] = null;
      }
      const totalQuantity = resItem?.supplyItems?.reduce((sum, item) => sum + (item?.qty || 0), 0) || 0;
      resItem["employeeName"] = `${userTimeSheet[0]?.firstName} ${userTimeSheet[0]?.lastName}`
      resItem["client"] = `${clientDetails?.clientName}`
      resItem["employeNameId"] = resItem?.createdBy;
      resItem["date"] = moment(resItem?.dateOfRequest).format("MMMM D, YYYY");
      resItem["qty"] = totalQuantity;
      resItem["urgent"] = resItem?.priority === "1" ? "Yes" : "No";
      resItem["approved"] = resItem?.approvedTime ? hoursDiff(resItem?.createdAt, resItem?.approvedTime) : "N/A";
      resItem["time"] = resItem?.finalizedTime ? hoursDiff(resItem?.createdAt, resItem?.finalizedTime) : "N/A";

      return resItem;
    });

    let sortedData = sortingFunction(finaleData);
    setEmployeeListMaster(sortedData);

    setEmployeeList(() =>
      sortedData?.filter((itme) => {
        let returnFlg = true;
        if (empName !== "All" && returnFlg) {
          returnFlg = itme.employeNameId === empName;
        }
        return returnFlg;
      })
    );
    setLoader(false);
  };

  const sortingFunction = (data) => {
    const result = data?.sort((a, b) => {
      if (a.employeeName < b.employeeName) return -1;
      if (a.employeeName > b.employeeName) return 1;

      if (a.appointmentDateTime < b.appointmentDateTime) return -1;
      if (a.appointmentDateTime > b.appointmentDateTime) return 1;
      return 0;
    });

    return result;
  };

  const getReportListData = async (startDt, endDt) => {
    const param = {
      startDate: `${dayjs(startDt).format("YYYY-MM-DD")}T00:00:00`,
      endDate: `${dayjs(endDt).format("YYYY-MM-DD")}T23:59:59`,
    };

    const suppliesPromise = new Promise((resolve, reject) => {
      getSuppliesReports(
        param,
        empName,
        companyId,
        (result) => resolve(result),
        (err) => reject(err)
      );
    });

    try {
      const [notesResult, suppliesResult] = await Promise.all([
        getSuppliesNotesReports(param, companyId),
        suppliesPromise,
      ]);

      mapWidhtEmpList({ notes: notesResult, supplies: suppliesResult });
    } catch (err) {
      console.error("Error fetching report data:", err);
    }
  };

  const renderItemsList = (items) => {
    // if (items?.length === 1) {
    //   return `${items[0]?.title} (${items[0]?.qty})`;
    // }

    return (
      <HoverCard>
        <HoverCardTrigger asChild>
          <button className="text-blue-600 dark:text-blue-400 hover:underline flex items-center gap-1">
            {items?.length} items
            <Eye className="h-3 w-3" />
          </button>
        </HoverCardTrigger>
        <HoverCardContent className="w-80 pt-4 ph-20 pb-10">
          <div className="space-y-2">
            <h4 className="text-sm font-semibold">Requested Items:</h4>
            <div className="space-y-1">
              {items?.map((item, index) => (
                <div key={index} className="text-sm flex justify-between">
                  <span>{item?.title}</span>
                  <span className="text-gray-500">({item?.qty})</span>
                </div>
              ))}
            </div>
          </div>
        </HoverCardContent>
      </HoverCard>
    );
  };

  const getStatusColor = (urgent) => {
    switch (urgent) {
      case 'No':
        return 'bg-gray-100 text-gray-800 dark:bg-gray-900/20 dark:text-gray-400';
      case 'Yes':
        return 'bg-red-100 text-red-800 dark:bg-red-900/20 dark:text-red-400';
      default:
        return 'bg-blue-100 text-blue-800 dark:bg-blue-900/20 dark:text-blue-400';
    }
  };

  const renderRowCell = (rcellItem, hcellItem, index, rowindex) => {
    switch (hcellItem.id) {
      case "employeeName":
        if (
          rowindex !== 0 &&
          employeeList[rowindex - 1].employeeName !== rcellItem.employeeName
        ) {
          return <div className="b-none">{rcellItem[hcellItem?.id]} </div>;
        } else if (rowindex === 0) {
          return <div className="b-none">{rcellItem[hcellItem?.id]} </div>;
        } else {
          return "";
        }
      case "comments":
        return rcellItem?.comments ? (
          <Tooltip>
            <TooltipTrigger asChild>
              <Button variant="ghost" size="sm" className="h-6 w-6 p-0">
                <Info className="h-3 w-3" />
              </Button>
            </TooltipTrigger>
            <TooltipContent className="max-w-xs">
              <p className="text-sm">{rcellItem?.comments}</p>
            </TooltipContent>
          </Tooltip>
        ) : (
          <Button variant="ghost" size="sm" className="h-6 w-6 p-0">
            <Info className="h-3 w-3" />
          </Button>
        );
      case "items":
        return renderItemsList(rcellItem?.supplyItems);
      case "urgent":
        return (
          <Badge className={getStatusColor(rcellItem?.urgent)}>
            {rcellItem?.urgent}
          </Badge>
        );
      case "client":
        const fullName = rcellItem?.client || "";
        const shortName =
          fullName?.length > 25 ? `${fullName?.slice(0, 25)}...` : fullName;
        return (
          <Tooltip>
            <TooltipTrigger asChild>
              <span className="cursor-default">{shortName}</span>
            </TooltipTrigger>
            <TooltipContent>{fullName}</TooltipContent>
          </Tooltip>
        );
      case "Action":
        if (isMobile || isLandscape) {
          if (rowindex === 0) {
            return (
              <ActionRender
                rcellItem={rcellItem}
                clientsListCSV={clientsListCSV}
                setDownloadCSVData={setDownloadCSVData}
                downloadPDF={downloadForPDF}
                downloadExcel={downloadForExcel}
                startDate={startDate}
                endDate={endDate}
                handleEmailIconClick={handleEmailIconClick}
                name={"UrgentSupplyPatternsReport"}
              />
            );
          } else {
            return null;
          }
        } else {
          if (
            rowindex !== 0 &&
            employeeList[rowindex - 1].employeNameId !==
            rcellItem.employeNameId
          ) {
            return (
              <ActionRender
                rcellItem={rcellItem}
                clientsListCSV={clientsListCSV}
                setDownloadCSVData={setDownloadCSVData}
                downloadPDF={downloadForPDF}
                downloadExcel={downloadForExcel}
                startDate={startDate}
                endDate={endDate}
                handleEmailIconClick={handleEmailIconClick}
                name={"UrgentSupplyPatternsReport"}
              />
            );
          } else if (rowindex === 0) {
            return (
              <ActionRender
                rcellItem={rcellItem}
                clientsListCSV={clientsListCSV}
                setDownloadCSVData={setDownloadCSVData}
                downloadPDF={downloadForPDF}
                downloadExcel={downloadForExcel}
                startDate={startDate}
                endDate={endDate}
                handleEmailIconClick={handleEmailIconClick}
                name={"UrgentSupplyPatternsReport"}
              />
            );
          } else {
            return "";
          }
        }
      default:
        return <div className="b-none">{rcellItem[hcellItem?.id]}</div>;
    }
  };

  const MobileViewData = useMemo(() => {
    if (!employeeList?.length) return [];

    return employeeList?.reduce((acc, item) => {
      const employeeName = item?.employeeName;

      const record = {
        id: item?.id,
        date: item?.date,
        client: item?.client,
        time: item?.time,
        approved: item?.approved,
        urgent: item?.urgent,
        qty: item?.qty,
        supplyItems: item?.supplyItems,
        employeNameId: item?.employeNameId,
        employeeName: item?.employeeName,
      };

      const existingGroup = acc?.find((g) => g?.employeeName === employeeName);

      if (existingGroup) {
        existingGroup?.records?.push(record);
      } else {
        acc?.push({
          employeeName,
          records: [record],
        });
      }

      return acc;
    }, []);
  }, [employeeList]);

  const filteredEmployee = employee?.find((item) => item?.id === empName);

  const handleEmailDialogClose = async () => {
    setOpenEmailDialog(false);
    await handleGenerateReport();
  }

  return (
    <>
      <Container>
        <PageTitle
          pageTitle="Urgent Supply Patterns Report"
          showBreadcrumb={[
            { label: "Home", to: "/" },
            { label: "Reports" },
            { label: "New Reports" },
            { label: "Employee Reports", to: "/reports/newreport/employeereport" },
          ]}
          BreadCrumbCurrentPageTitle={"Urgent Supply Patterns Report"}
          showLastSeen={true}
        ></PageTitle>

        <div className={`sectionBox2 dark:bg-[#1A1F2C]`}>
          <div className="mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 max-w-7xl dark:bg-[#1A1F2C]">
            <div className="space-y-6">
              <Card className="shadow-sm dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] p-24">
                <CardHeader className="pb-12">
                  <div className="flex items-center space-x-2">
                    <Filter className="w-4 h-4 sm:w-5 sm:h-5 text-primary" />
                    <CardTitle className="text-lg sm:text-xl">
                      Report Parameters
                    </CardTitle>
                  </div>
                  <CardDescription className="text-left text-sm sm:text-base">
                    Configure the parameters for your Urgent Supply Patterns Report
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
                    {/* Employee Select */}
                    <div className="flex flex-col space-y-1">
                      <Label
                        htmlFor="employee"
                        className="text-sm font-medium text-gray-700 dark:text-white"
                      >
                        Employee Name *
                      </Label>
                      <SingleSelectNew
                        value={empName}
                        name="employeeName"
                        label="Employee Name"
                        onChange={(e) => handleEmpNameChange(e)}
                        contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                        itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                        options={empNameList}
                        className="w-full min-h-[40px] px-3 py-2"
                      />
                    </div>

                    {/* Start Date */}
                    <div className="flex flex-col space-y-1">
                      <Label
                        htmlFor="startDate"
                        className="text-sm font-medium text-gray-700 dark:text-white"
                      >
                        Start Date *
                      </Label>
                      <LocalizationProvider dateAdapter={AdapterMoment}>
                        <DatePicker
                          value={startDate}
                          onChange={(newValue) => {
                            setStartDate(newValue);
                            // if (newValue) {
                            //   setEndDate(moment());
                            // } else {
                            //   setEndDate(null);
                            // }
                          }}
                          maxDate={moment()}
                          views={["year", "month", "day"]}
                          inputFormat="YYYY-MM-DD"
                          slotProps={{
                            textField: {
                              variant: "outlined",
                              size: "small",
                              fullWidth: true,
                              className: "customDateInput",
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </div>

                    {/* End Date */}
                    <div className="flex flex-col space-y-1">
                      <Label
                        htmlFor="endDate"
                        className="text-sm font-medium text-gray-700 dark:text-white"
                      >
                        End Date *
                      </Label>
                      <LocalizationProvider dateAdapter={AdapterMoment}>
                        <DatePicker
                          value={endDate}
                          onChange={(newValue) => {
                            setEndDate(newValue);
                            // if (!newValue) {
                            //   setStartDate(null);
                            // }
                          }}
                          maxDate={moment()}
                          views={["year", "month", "day"]}
                          inputFormat="YYYY-MM-DD"
                          slotProps={{
                            textField: {
                              variant: "outlined",
                              size: "small",
                              fullWidth: true,
                              className: "customDateInput",
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </div>
                  </div>
                  <div className="flex justify-start sm:justify-end pt-8">
                    <Button
                      type="submit"
                      className="w-full sm:w-auto h-10 text-sm px-6"
                      onClick={() => handleGenerateReport()}
                    >
                      {loader ? (
                        <CircularProgress
                          size={28}
                          style={{ color: "white" }}
                        />
                      ) : (
                        <span className="d-flex flex-center">
                          <FileText className="w-4 h-4 mr-8" /> Generate Report
                        </span>
                      )}
                    </Button>
                  </div>
                </CardContent>
              </Card>
              {loader ? (
                <Card className="shadow-sm p-24 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] flex items-center justify-center min-h-[200px]">
                  <div className="text-sm sm:text-base text-gray-600 dark:text-gray-300">
                    Fetching report data...
                  </div>
                </Card>
              ) : employeeList?.length === 0 ? (
                <Card className="shadow-sm p-24 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] flex items-center justify-center min-h-[200px]">
                  <div className="text-sm sm:text-base text-gray-600 dark:text-gray-300">
                    No Records Found
                  </div>
                </Card>
              ) : (
                employeeList?.length > 0 && (
                  <Card className="shadow-sm p-24 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]">
                    <CardHeader className="pb-16">
                      <div className="flex flex-col space-y-4 lg:flex-row lg:items-start lg:justify-between lg:space-y-0">
                        <div className="space-y-3 flex-1 min-w-0">
                          <div className="flex items-center space-x-2">
                            <WarningAmber className="h-5 w-5 mr-3 text-red-600 dark:text-blue-400" />
                            <CardTitle className="text-lg sm:text-xl">
                              Urgent Supply Patterns Results
                            </CardTitle>
                          </div>
                          <CardDescription className="space-y-2">
                            <div className="font-medium text-sm sm:text-base">
                              {empName === "All"
                                ? "Requests by Employee Results"
                                : `Employee Report for ${filteredEmployee?.firstName} ${filteredEmployee?.lastName}`}
                            </div>
                            <div className="text-xs sm:text-sm text-gray-600 dark:text-gray-400"></div>
                          </CardDescription>
                        </div>
                        <div className="flex flex-wrap gap-2">
                          <Button
                            variant="outline"
                            size="sm"
                            onClick={() => handelEmailFullReport()}
                            className="h-8"
                          >
                            <Mail className="mr-4 h-3 w-3" />
                            Email Report
                          </Button>
                          <Popover>
                            <PopoverTrigger asChild>
                              <Button
                                variant="outline"
                                size="sm"
                                className="h-8"
                              >
                                <Download className="mr-4 h-3 w-3" />
                                Download
                              </Button>
                            </PopoverTrigger>
                            <PopoverContent className="w-40">
                              <div className="space-y-2">
                                <Button
                                  variant="ghost"
                                  className="w-full justify-start h-8"
                                  onClick={() => downloadForFullPDF()}
                                >
                                  <FileText className="mr-8 h-3 w-3" />
                                  PDF
                                </Button>
                                <Button
                                  variant="ghost"
                                  className="w-full justify-start h-8"
                                  onClick={() => downloadForFullExcel()}
                                >
                                  <FileSpreadsheet className="mr-8 h-3 w-3" />
                                  Excel
                                </Button>
                                <CSVLink
                                  data={clientsListCSV}
                                  filename={`UrgentSupplyPatternsReport_${empName === "All"
                                      ? "All"
                                      : `${filteredEmployee?.firstName} ${filteredEmployee?.lastName}`
                                    }_${moment(startDate).format(
                                      "YYYY-MM-DD"
                                    )}_${moment(endDate).format(
                                      "YYYY-MM-DD"
                                    )}.csv`}
                                  asyncOnClick={true}
                                  onClick={(event, done) => {
                                    setDownloadFullCSVData(event, done);
                                  }}
                                  className="w-full flex justify-start items-center h-8 pv-8 ph-16 text-sm hover:bg-accent hover:text-accent-foreground rounded-md transition-colors"
                                >
                                  <FileSpreadsheet className="mr-16 h-4 w-4" />
                                  <span className="font-medium">CSV</span>
                                </CSVLink>
                              </div>
                            </PopoverContent>
                          </Popover>
                        </div>
                      </div>
                    </CardHeader>
                    <CardContent className="p-0 sm:p-6 sm:pt-0">
                      {!isMobile && (
                        <TooltipProvider>
                          <ThemeTable
                            rows={employeeList}
                            headCells={getColumns()}
                            hidePagination={true}
                            // isLoading={isLoading}
                            renderRowCell={renderRowCell}
                          />
                        </TooltipProvider>
                      )}
                      {isMobile &&
                        <MobileUrgentSupplyReport
                          MobileViewData={MobileViewData}
                          handleEmailIconClick={handleEmailIconClick}
                          downloadForPDF={downloadForPDF}
                          downloadForExcel={downloadForExcel}
                          clientsListCSV={clientsListCSV}
                          setDownloadCSVData={setDownloadCSVData}
                          startDate={startDate}
                          endDate={endDate}
                          reportName={'UrgentSupplyPatternsReport'}
                        />}
                    </CardContent>
                  </Card>
                )
              )}
            </div>
          </div>
        </div>
        <EmailReports
          open={openEmailDialog}
          onClose={() => handleEmailDialogClose()}
        />
      </Container>
    </>
  );

}
export default UrgentSupplyPatterns;